import React from "react";
import {SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../constants";
import WallsUpModeButton from "./menuSecondRowButtons/WallsUpModeButton";
import WallsLockModeButton from "./menuSecondRowButtons/WallsLockModeButton";
import ShowMeasurementsInTheSlabModeButton from "./menuSecondRowButtons/ShowMeasurementsInTheSlabModeButton";
import {connect} from "react-redux";

const NavigationSidebarSecondRow = ({ isMobile, menuOpened, isCabinet, activeButton, isShowSlabTool }) => {
  let left = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall ?  "418px" : "118px";
  let top = "35px";
  if (isMobile) {
    left = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall ?  "322px" : "90px";
    top = "20px";
  }

  return (
    <div
      className="sqft-nav__second"
      style={{
        position: "absolute",
        //left: `${leftPosition}px`,
        left: left,
        top: top,
        zIndex: 3,
        transition: "all 0.3s ease-in-out",
      }}
    >
      {/*<FreeDrawModeButton />*/}
      { isCabinet && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall ? <WallsUpModeButton /> : null }
      { isCabinet && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall
      || !isCabinet && !isShowSlabTool
        ? <WallsLockModeButton />
        : null
      }
      { isShowSlabTool ? <ShowMeasurementsInTheSlabModeButton /> : null }
    </div>
  );
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
  isMobile: store.serverState.isMobile,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationSidebarSecondRow);
